import { Fragment } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Breadcrumbs from 'shell/components/shared/breadcrumb';
import Form, { TypeDocForm } from 'front-office/components/type-doc/form';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { __CERTIFICATION_API_URL__ } from 'shell/constants/environment';
import { noop } from 'shell/utils/noop';
import { typeDocCrubs } from 'front-office/constants/type-doc-crubs';
import { TypeDoc } from 'shell/models/type-doc';
import { transformTypeDoc } from 'front-office/components/type-doc/utils/transform-type-doc';

const TypeDocDetail = (): React.ReactElement => {
  const params = useParams();

  const [typeDoc] = useHttpFetch<HttpResponse<TypeDoc>, TypeDocForm>(
    `${__CERTIFICATION_API_URL__}/certificazione/tipi-documento/${params.idDoc}/${params.id}`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: {},
      },
      transformer: transformTypeDoc,
    }
  );

  const navigate = useNavigate();

  const loading = typeDoc.isLoading || typeDoc.pristine || typeDoc.hasErrors;

  return (
    <Fragment>
      <Breadcrumbs items={[...typeDocCrubs, { name: 'Dettaglio Tipo documento' }]} />
      {loading ? null : (
        <Form
          title="Dettaglio Tipo documento"
          onOk={noop}
          initialValues={typeDoc.data as TypeDocForm}
          onCancel={() => {
            navigate('/sportello/tipo-doc');
          }}
          disabled
        />
      )}
    </Fragment>
  );
};

TypeDocDetail.displayName = 'type document detail page component';

export default TypeDocDetail;
